import CorePricedItemAdditionalFees from './CorePricedItemAdditionalFees';
import LineItemTaxInfo from './LineItemTaxInfo';
import PriceCents from './PriceCents';

type CorePricingBreakdown = {
  name: string;
  value: string;
  listPriceCents: PriceCents;
  discountedPriceCents: PriceCents;
};

type DiscountSourceReference = {
  promotionId: string;
};

class CorePricedItem {
  correlationId: string;

  productKey: string;

  quantity: number;

  totalListPriceCents: PriceCents;

  totalDiscountedPriceCents: PriceCents;

  baseListPriceCents: PriceCents;

  baseDiscountedPriceCents: PriceCents;

  itemTaxInfo: LineItemTaxInfo;

  breakdown: CorePricingBreakdown[];

  statusCode: number;

  statusReason: string;

  shippingListPriceCents: PriceCents;

  shippingDiscountedPriceCents: PriceCents;

  shippingItemTaxInfo: LineItemTaxInfo;

  additionalFees: CorePricedItemAdditionalFees;

  discountSources: DiscountSourceReference[];

  base_PRICE: string;

  constructor() {
    this.correlationId = '';
    this.productKey = '';
    this.quantity = 0;
    this.totalListPriceCents = new PriceCents();
    this.totalDiscountedPriceCents = new PriceCents();
    this.baseListPriceCents = new PriceCents();
    this.baseDiscountedPriceCents = new PriceCents();
    this.itemTaxInfo = new LineItemTaxInfo();
    this.breakdown = [];
    this.statusCode = 0;
    this.statusReason = '';
    this.shippingListPriceCents = new PriceCents();
    this.shippingDiscountedPriceCents = new PriceCents();
    this.shippingItemTaxInfo = new LineItemTaxInfo();
    this.additionalFees = new CorePricedItemAdditionalFees();
    this.discountSources = [];
    this.base_PRICE = '';
  }
}

export default CorePricedItem;
